import { useEffect, useRef } from "react";
import { styled, Theme } from "@mui/material/styles";

import MenuBar from "./components/video/MenuBar/MenuBar";
import MobileTopMenuBar from "./components/video/MobileTopMenuBar/MobileTopMenuBar";
import PreJoinScreens from "./components/video/PreJoinScreens/PreJoinScreens";
import ReconnectingNotification from "./components/video/ReconnectingNotification/ReconnectingNotification";
import RecordingNotifications from "./components/video/RecordingNotifications/RecordingNotifications";
import Room from "./components/video/Room/Room";

import useHeight from "./hooks/useHeight/useHeight";
import useRoomState from "./hooks/useRoomState/useRoomState";
import { Redirect } from "react-router-dom";
import { useVideoState } from "./state";

const Container = styled("div")({
  display: "grid",
  gridTemplateRows: "1fr auto"
});

const Main = styled("main")(({ theme }: { theme: Theme }) => ({
  overflow: "hidden",
  paddingBottom: `${theme.footerHeight}px`,
  background: "black",
  [theme.breakpoints.down("md")]: {
    paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`
  }
}));

export default function JoinVideo() {
  const roomState = useRoomState();
  const { endRoom } = useVideoState();
  const height = useHeight();

  const wasConnected = useRef(false);
  useEffect(() => {
    if (roomState === "connected" || roomState === "reconnecting") {
      wasConnected.current = true;
    }
  }, [roomState]);

  if (roomState === "disconnected" && (endRoom || wasConnected.current)) {
    return (
      <Redirect
        to={{ pathname: "/app/state/disconnected", state: { isPatient: true } }}
      />
    );
  }

  return (
    <Container style={{ height }}>
      {roomState === "disconnected" ? (
        <PreJoinScreens />
      ) : (
        <Main>
          <ReconnectingNotification />
          <RecordingNotifications />
          <MobileTopMenuBar />
          <Room />
          <MenuBar />
        </Main>
      )}
    </Container>
  );
}
